// src/data/courses.js

// 類別（用於篩選）
export const categories = ['All', 'EVM', 'Solana', 'Bonus']

// 课程数据（先用本地 mock，之後可替換為 API）
export const courses = [
  {
    id: 'web3-bootcamp-1',
    title: 'Web3.0項目速成課程 1.0 (EVM以太坊系-Solidity)',
    desc: '2個月助你做出自己的 DApp 專案：從 Solidity、Hardhat 測試到前端 ethers.js 互動與部署。',
    cover: '/images/course-evm-1.jpg',
    lessonsCount: 31,
    level: 'Intermediate',
    isPaid: true,
    category: 'EVM',
    // 播放頁預設影片（可被 lessons 覆蓋）
    videoUrl: 'https://youtu.be/nJtinqWl6h4',
    
    lessons: [
      { id: 'l1',  title: '1️⃣ 認識智能合約與 EVM 基礎',            videoUrl: 'https://youtu.be/nJtinqWl6h4',
        attachments: [
      { name: '課程大綱.pdf', url: '/files/evm-course-outline.pdf', size: '1.2 MB' },
      { name: '範例專案模板.zip', url: '/files/evm-starter.zip', size: '4.8 MB' },
    ],
       },
      { id: 'l2',  title: '2️⃣ 用 Remix 撰寫第一個合約',              videoUrl: 'https://youtu.be/nJtinqWl6h4' },
      { id: 'l3',  title: '3️⃣ Hardhat 專案初始化與測試',             videoUrl: 'https://youtu.be/nJtinqWl6h4' },
      { id: 'l4',  title: '4️⃣ 部署到測試網與驗證合約',               videoUrl: 'https://youtu.be/nJtinqWl6h4' },
      { id: 'l5',  title: '5️⃣ 前端整合 ethers.js 互動',              videoUrl: 'https://youtu.be/nJtinqWl6h4' },
      { id: 'l6',  title: '6️⃣ 常見安全檢查與最佳實踐',               videoUrl: 'https://youtu.be/nJtinqWl6h4' }
    ]
  },
  {
    id: 'web3-bootcamp-2',
    title: 'Web3.0項目速成課程 2.0 (SOLANA 鏈—Seahorse)',
    desc: '可能是全網最實用的 Solana 項目開發課程：Seahorse 撰寫合約、Anchor 互動、PDA 與前端整合。',
    cover: '/images/course-solana-2.jpg',
    lessonsCount: 42,
    level: 'None',
    isPaid: true,
    category: 'Solana',
    videoUrl: 'https://youtu.be/nJtinqWl6h4',
    lessons: [
      { id: 'l1', title: '1️⃣ 開發環境與錢包配置',          videoUrl: 'https://youtu.be/nJtinqWl6h4' },
      { id: 'l2', title: '2️⃣ 用 Seahorse 撰寫第一個指令',  videoUrl: 'https://youtu.be/_K6BbtLLN6o' },
      { id: 'l3', title: '3️⃣ Anchor 與 PDA：帳戶與資料結構', videoUrl: 'https://youtu.be/_z2jM5IXXeE' },
      { id: 'l4', title: '4️⃣ 前端（Vue）連接與交易簽名',    videoUrl: 'https://youtu.be/5zdC7Kp3O5A' },
      { id: 'l5', title: '5️⃣ 測試、部署與常見錯誤排除',      videoUrl: 'https://youtu.be/R0R3n8W6s0o' }
    ]
  },
  {
    id: 'web3-bootcamp-3',
    title: 'Web3.0項目速成課程 3.0 (Solana 鏈–自動化交易腳本)',
    desc: '帶你做屬於自己的 pumpfun 與 Jupiter 交易腳本：行情監控、下單邏輯、風控與自動化部署。',
    cover: '/images/course-solana-3.jpg',
    lessonsCount: 20,
    level: 'None',
    isPaid: true,
    category: 'Solana',
    videoUrl: 'https://youtu.be/nJtinqWl6h4',
    lessons: [
      { id: 'l1', title: '1️⃣ Jupiter API 與行情訂閱',       videoUrl: 'https://youtu.be/nJtinqWl6h4' },
      { id: 'l2', title: '2️⃣ 策略架構：觸發條件與風控',       videoUrl: 'https://youtu.be/VpO8sZDxOGI' },
      { id: 'l3', title: '3️⃣ 下單流程與錢包管理',           videoUrl: 'https://youtu.be/HpW4IxvEX0E' },
      { id: 'l4', title: '4️⃣ 監控告警與日誌設計',           videoUrl: 'https://youtu.be/7vHzVN0EiNc' },
      { id: 'l5', title: '5️⃣ 上線運維：PM2/Docker',        videoUrl: 'https://youtu.be/7N3nR6fUjNw' }
    ]
  },
  {
    id: 'big-gift-pack',
    title: '學員可獲得 – 大禮包資料',
    desc: '心法與總結、研讀清單、國外開發者經驗資料、專案模板與 Checklist，助你快速落地實作。',
    cover: '/images/course-giftpack.jpg',
    lessonsCount: 50,
    level: 'None',
    isPaid: true,
    category: 'Bonus',
    videoUrl: 'https://youtu.be/nJtinqWl6h4', // 可替換成導覽影片
    lessons: [
      { id: 'l1', title: '1️⃣ 學習藍圖與路線規劃',     videoUrl: 'https://youtu.be/nJtinqWl6h4' },
      { id: 'l2', title: '2️⃣ 推薦閱讀與資源導航',       videoUrl: 'https://youtu.be/YbJOTdZBX1g' },
      { id: 'l3', title: '3️⃣ 專案模板與最佳實踐',       videoUrl: 'https://youtu.be/dQw4w9WgXcQ' }
    ]
  }
]
